import React, { useCallback } from 'react';
import { Link, Text } from 'roo-ui/components';
import { QH_DREAM_PLANNER_URL } from 'config';
import { useDataLayer } from 'hooks/useDataLayer';

const DreamPlannerLink = () => {
  const { emitInteractionEvent } = useDataLayer();

  const onClick = useCallback(() => {
    emitInteractionEvent({ type: 'Member Favourites Button', value: 'View Dream Planner Selected' });
  }, [emitInteractionEvent]);

  return (
    <Link
      color="greys.steel"
      href={QH_DREAM_PLANNER_URL}
      onClick={onClick}
      rel="noopener noreferrer"
      target="_blank"
      mr={4}
      aria-label="Dream Planner (opens in new tab)"
    >
      <Text textDecoration="underline">Dream Planner</Text>
    </Link>
  );
};

export default DreamPlannerLink;
